import {combineReducers} from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'
import comments from './comments'
import reports from './reports'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        base,
        comments,
        reports,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
